module.exports = "/static-assets/_next/static/images/paperclip-60d5d55e43c4108270552db22360eb69.png";